module.exports = __webpack_public_path__ + "static/redux-logo-62cc7d7a7701fc5c78e8bfdfe1c58ad7.png";